import React from "react";
import { PrismicRichText as BasePrismicRichText } from "@prismicio/react";

export const richTextComponents = {
  preformatted: ({ node }) => (
    <p dangerouslySetInnerHTML={{ __html: node?.text ?? "" }} />
  ),
  label: ({ node, children }) => {
    if (node?.data?.label === "button") {
      return (
        <span className="app-btn mona custom-button text-center fw-bold">
          {children}
        </span>
      );
    }
    return <span className={`label-${node?.data?.label ?? ""}`}>{children}</span>;
  },
};
const createClassedComponents = (className) => ({
  heading1: ({ children }) => <h1 className={className}>{children}</h1>,
  heading2: ({ children }) => <h2 className={className}>{children}</h2>,
  heading3: ({ children }) => <h3 className={className}>{children}</h3>,
  heading4: ({ children }) => <h4 className={className}>{children}</h4>,
  heading5: ({ children }) => <h5 className={className}>{children}</h5>,
  heading6: ({ children }) => <h6 className={className}>{children}</h6>,
  paragraph: ({ children }) => <p className={className}>{children}</p>,
  listItem: ({ children }) => <li className={className}>{children}</li>,
  oListItem: ({ children }) => <li className={className}>{children}</li>,
  preformatted: ({ node }) => (
    <p
      className={className}
      dangerouslySetInnerHTML={{ __html: node?.text ?? "" }}
    />
  ),
});

export const PrismicRichText = ({
  components,
  className,
  field,
  fallback,
  linkResolver,
  internalLinkComponent,
}) => {
  const classedComponents = className
    ? createClassedComponents(className)
    : undefined;

  return (
    <BasePrismicRichText
      field={field}
      fallback={fallback}
      linkResolver={linkResolver}
      internalLinkComponent={internalLinkComponent}
      components={{
        ...richTextComponents,
        ...classedComponents,
        ...components,
      }}
    />
  );
};
